var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 35,
    viewBox: "0 0 28 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 14C17.8675 14 21 10.8675 21 7C21 3.1325 17.8675 0 14 0C10.1325 0 6.99999 3.1325 6.99999 7C6.99999 10.8675 10.1325 14 14 14ZM14 3.5C15.925 3.5 17.5 5.075 17.5 7C17.5 8.925 15.925 10.5 14 10.5C12.075 10.5 10.5 8.925 10.5 7C10.5 5.075 12.075 3.5 14 3.5ZM25.1825 18.48C22.2425 16.975 18.4275 15.75 14 15.75C9.57249 15.75 5.75749 16.975 2.81749 18.48C1.96359 18.9198 1.24827 19.5876 0.750916 20.4093C0.253563 21.2311 -0.00636145 22.1745 -8.33732e-06 23.135V35H3.49999V23.135C3.49999 22.47 3.84999 21.875 4.37499 21.595C6.49249 20.5275 9.85249 19.25 14 19.25C15.33 19.25 16.5725 19.3725 17.7275 19.6L15.015 25.375H10.0625C7.40249 25.375 5.24999 27.5275 5.24999 30.1875C5.24999 32.8475 7.40249 35 10.0625 35H24.5C26.425 35 28 33.425 28 31.5V23.135C28 21.175 26.9325 19.3725 25.1825 18.48ZM12.145 31.5H10.0625C9.34499 31.5 8.74999 30.905 8.74999 30.1875C8.74999 29.47 9.34499 28.875 10.0625 28.875H13.37L12.145 31.5ZM24.5 31.5H16.0125L21.1575 20.5275C22.1025 20.8775 22.925 21.245 23.625 21.595C24.15 21.875 24.5 22.47 24.5 23.135V31.5Z",
    fill: "#239EC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPatient);
export default __webpack_public_path__ + "static/media/colorPatient.215026bb39835655ada9197cd048b489.svg";
export { ForwardRef as ReactComponent };